export const bulkGeneration = {
  brandVoice: {
    label: 'Voz de Marca',
    loading: 'Cargando voces de marca...',
    placeholder: 'Selecciona una voz de marca',
    new: 'Nueva',
    create: 'Crear Voz de Marca',
  },
  interlinking: {
    label: 'Sitio Web para Interlinking',
    description:
      'Selecciona un sitio web para buscar e insertar enlaces internos relevantes en el contenido generado',
    placeholder: 'Selecciona un sitio web (opcional)',
    empty: 'No hay sitios web configurados. Agrega uno en la configuración de la organización.',
    manage: 'Gestionar Sitios Web',
  },
  folder: {
    label: 'Carpeta de Destino',
    description: 'Todos los artículos generados se guardarán en esta carpeta',
    placeholder: 'Selecciona una carpeta (opcional)',
    empty: 'No hay carpetas. Crea una para organizar tu contenido.',
    create: 'Crear Carpeta',
    change: 'Cambiar carpeta',
    searchFolders: 'Buscar carpetas...',
    noFoldersFound: 'No se encontraron carpetas',
    namePlaceholder: 'Nombre de la carpeta...',
    alreadyExists: 'Ya existe una carpeta con este nombre',
    color: 'Color',
    cancel: 'Cancelar',
  },
  tags: {
    label: 'Tags',
    description: 'Los tags se aplicarán a todos los artículos generados en este lote',
    addTag: 'Agregar tag',
    searchTags: 'Buscar tags...',
    noTagsFound: 'No se encontraron tags',
    empty: 'No hay tags aún',
    createNewTag: 'Crear nuevo tag',
    tagNamePlaceholder: 'Nombre del tag...',
    alreadyExists: 'Ya existe un tag con este nombre',
    tagColor: 'Color',
    cancel: 'Cancelar',
    create: 'Crear',
    selected: '{{count}} tags seleccionados',
  },
  factUpdate: {
    label: 'Actualización de Datos',
    description: 'Enriquecer el contenido con datos y estadísticas recientes de la web',
    enabled: 'Activar actualización de datos',
    timeframe: 'Período',
    timeframes: {
      last_24h: 'Últimas 24 horas',
      last_week: 'Última semana',
      last_month: 'Último mes',
      last_3_months: 'Últimos 3 meses',
      last_year: 'Último año',
    },
  },
  imageConfig: {
    label: 'Generación de Imágenes',
    description:
      'Configura los ajustes de generación de imágenes para todos los artículos de este lote',
    count: 'Imágenes por artículo',
    countHelper: '(0-5 imágenes)',
    prompt: 'Estilo imágenes de sección (opcional)',
    promptPlaceholder: 'ej., Minimalista, colores corporativos',
    heroPrompt: 'Estilo imagen hero (opcional)',
    heroPromptPlaceholder: 'ej., Cinematográfico, panorámico, colores vibrantes',
    heroPromptHelper: 'Instrucciones específicas para la imagen de portada. Si está vacío, usa el estilo de sección',
    styleLabel: 'Estilo visual',
    sourceLabel: 'Fuente de imágenes',
    sourceStock: 'Fotos de Stock',
    sourceAi: 'Generadas por IA',
    stockHelper:
      'Las imágenes se obtendrán de fotos de stock de Magnific basadas en el título y secciones del contenido',
    aiFallbackLabel: 'Usar imágenes IA si el stock no está disponible',
    aiFallbackHelper:
      'Si el proveedor de stock falla, se usan imágenes generadas con IA. Desactívalo para dejar el contenido sin imágenes.',
  },
  actions: {
    addManually: 'Agregar Manualmente',
    uploadCSV: 'Subir CSV',
    loadSampleData: 'Cargar Datos de Prueba',
    generateAllBriefs: 'Generar Todos los Briefs ({{count}})',
    generatingBriefs: 'Generando {{current}}/{{total}}...',
    delete: 'Eliminar',
  },
  status: {
    valid: '{{count}} listos',
    needAttention: '{{count}} con errores',
    selected: '{{count}} seleccionados',
    itemsTotal: '{{count}} ítems',
  },
  empty: {
    title: 'Comenzá una generación masiva',
    description:
      'Subí un CSV o agregá filas manualmente para redactar hasta 50 artículos a la vez.',
    uploadCSV: 'Subir CSV',
    addManually: 'Agregar manual',
  },
  settings: {
    title: 'Configuración del batch',
    description: 'Estas opciones aplican a todos los artículos generados en este batch.',
    button: 'Configuración',
    clear: 'Limpiar',
  },
  generate: {
    selectBrandVoiceFirst: 'Seleccioná una voz de marca primero',
    noSelection: 'Seleccioná los contenidos a generar',
    selectionSummary: '{{selected}} de {{total}} seleccionados',
    invalidSelected: '{{count}} seleccionado(s) con errores. Corregilos o desseleccionalos para continuar.',
    initiating: 'Iniciando...',
    generate: 'Generar',
    generateArticle: 'Generar {{count}} artículo',
    generateArticles: 'Generar {{count}} artículos',
    error: 'Error al iniciar la generación masiva. Inténtalo de nuevo.',
  },
  table: {
    columns: {
      title: 'Título',
      mainKeyword: 'Keyword Principal',
      secondaryKeywords: 'Keywords Sec.',
      entity: 'Entidad',
      approach: 'Enfoque',
      language: 'Idioma',
      questions: 'Preguntas',
      sources: 'Fuentes',
      customPrompt: 'Prompt Personalizado',
      brief: 'Brief',
      status: 'Estado',
      error: 'Error',
      actions: 'Acciones',
      row: 'Fila',
    },
    empty: 'Aún no hay elementos. Haz clic en "Agregar Manualmente" para comenzar.',
    placeholders: {
      title: 'Título del contenido...',
      keyword: 'Keyword...',
      secondaryKeywords: 'kw1, kw2...',
      entity: 'Entidad...',
      approach: 'Describe el enfoque...',
      questions: 'Una pregunta por línea...',
      sources: 'url1, url2...',
      customPrompt: 'Instrucciones adicionales...',
      brief: 'Brief (mín 100 caracteres)...',
    },
    brief: {
      generateTooltip: 'Generar brief con IA',
      disabledTooltip: 'Completa título, keyword, entidad y enfoque primero',
      generating: 'Generando...',
      aiBrief: 'Brief IA',
    },
    validation: {
      missing: 'Falta: {{fields}}',
    },
    openEditor: 'Abrir editor completo',
  },
  csv: {
    dropHere: 'Suelta el archivo CSV aquí...',
    dragDrop: 'Arrastra y suelta un archivo CSV aquí, o haz clic para seleccionar',
    maxRows: 'Máximo 50 filas',
    validating: 'Validando...',
    validate: 'Validar y Subir',
    downloadTemplate: 'Descargar Plantilla',
    clearFile: 'Limpiar',
    validation: {
      valid: '{{count}} válidos',
      invalid: '{{count}} inválidos',
      totalRows: '{{count}} filas en total',
      proceed: 'Continuar con {{count}} elementos',
      validBadge: 'Válido',
      invalidBadge: 'Inválido',
    },
  },
  csvDialog: {
    title: 'Importar CSV',
    description: 'Subí un archivo CSV con tu plan de contenidos.',
    templateTitle: 'Plantilla CSV',
    templateDescription: 'Descargá la plantilla con todos los campos aceptados',
    uploadAnother: 'Subir otro',
    limitWarning: 'Solo {{max}} de {{valid}} filas válidas serán importadas (máximo 50 elementos)',
    cancel: 'Cancelar',
    import: 'Importar {{count}} elementos',
  },
  jobProgress: {
    title: 'Progreso de Generación Masiva',
    jobId: 'ID del Trabajo:',
    loading: 'Cargando detalles del trabajo...',
    notFound: 'Trabajo no encontrado',
    retrying: 'Reintentando...',
    retryFailed: 'Reintentar Fallidos ({{count}})',
    items: 'Elementos ({{count}})',
    allCompleted: '¡Todos los elementos completados!',
    allCompletedWithFailed: '¡Todos los elementos completados! ({{count}} fallidos)',
  },
  itemStatus: {
    pending: 'Pendiente',
    queued: 'En Cola',
    processing: 'Generando',
    completed: 'Completado',
    failed: 'Fallido',
  },
  progress: {
    completed: '{{completed}} / {{total}} completados',
    completedLabel: 'Completados:',
    generatingLabel: 'Generando:',
    failedLabel: 'Fallidos:',
  },
  editor: {
    untitled: 'Elemento Sin Título',
    itemOf: 'Elemento {{current}} de {{total}}',
    contentData: 'Datos del Contenido',
    fields: {
      title: 'Título',
      mainKeyword: 'Keyword Principal',
      mainEntity: 'Entidad Principal',
      secondaryKeywords: 'Keywords Secundarias',
      contentApproach: 'Enfoque del Contenido',
      language: 'Idioma',
      questionsToAnswer: 'Preguntas a Responder',
      referenceSources: 'Fuentes de Referencia',
      customPrompt: 'Prompt Personalizado',
      linkedinPosts: 'Posts de LinkedIn',
      internalSources: 'Fuentes Internas',
    },
    placeholders: {
      title: 'Ingresa el título del contenido',
      mainKeyword: 'Keyword principal',
      mainEntity: 'Entidad principal',
      secondaryKeywords: 'keyword1, keyword2, keyword3',
      contentApproach: 'Describe el ángulo y la estructura del contenido...',
      questionsToAnswer: 'Una pregunta por línea',
      referenceSources: 'https://ejemplo.com, https://otro.com',
      customPrompt: 'Instrucciones adicionales para la IA...',
      brief: 'Describe la estructura del contenido, temas clave a cubrir y ángulos específicos...',
      linkedinPostUrl: 'https://linkedin.com/posts/...',
      internalSourceUrl: 'https://ejemplo.com/recurso',
    },
    help: {
      separateWithCommas: 'Separar con comas',
      oneQuestionPerLine: 'Una pregunta por línea',
      linkedinPostsHelp: 'Agrega URLs de posts de LinkedIn como fuentes de referencia para la generación de contenido',
      internalSourcesHelp: 'Agrega URLs de documentos o páginas internas para usar como material fuente',
    },
    linkedinPosts: {
      add: 'Agregar Post de LinkedIn',
      urlLabel: 'URL del Post',
      remove: 'Eliminar',
      empty: 'No se agregaron posts de LinkedIn',
    },
    internalSources: {
      add: 'Agregar Fuente',
      urlLabel: 'URL de la Fuente',
      remove: 'Eliminar',
      empty: 'No se agregaron fuentes internas',
    },
    languages: {
      en: 'Inglés',
      es: 'Español',
      pt: 'Portugués',
    },
    brief: {
      label: 'Brief',
      generating: 'Generando...',
      generate: 'Generar Brief',
      charactersNeeded: '{{count}} caracteres más necesarios',
      meetsMinimum: 'El brief cumple la longitud mínima',
      charCount: '{{current}}/{{max}}',
    },
    disabledReasons: {
      selectBrandVoice: 'Selecciona una voz de marca primero',
      titleRequired: 'El título es requerido',
      mainKeywordRequired: 'La keyword principal es requerida',
      mainEntityRequired: 'La entidad principal es requerida',
      approachTooShort: 'El enfoque necesita al menos 10 caracteres',
    },
    actions: {
      close: 'Cerrar',
      saveAndClose: 'Guardar y Cerrar',
    },
  },
  routes: {
    bulkGeneration: 'Generación Masiva',
    bulkJobProgress: 'Progreso del Trabajo',
  },
  itemsTable: {
    view: 'Ver',
  },
} as const
